// Get the modal
if(document.getElementById("myModal-ithelps")) {
  var modal = document.getElementById("myModal-ithelps");
  var modal2 = document.getElementById("myModal-ithelps-2");

  // Get the button that opens the modal
  var btn = document.getElementById("myBtn-ithelps");
  var btn2 = document.getElementById("myBtn-ithelps-2");

  // Get the <span> element that closes the modal
  var span = document.querySelectorAll(".close");

  // When the user clicks on the button, open the modal
  if (btn) {
    btn.onclick = function() {
      modal.style.display = "block";
    }
  }

  if (btn2 && modal2) {
    btn2.onclick = function() {
      modal2.style.display = "block";
      modal2.style.zIndex = "2";
    }
  }

  // When the user clicks on <span> (x), close the modal
  // span.onclick = function() {
  //   modal.style.display = "none";
  // }

  span.forEach(el => {
    el.addEventListener("click", () => {
      modal.style.display = "none"
      if (modal2) {
        modal2.style.display = "none"
      }
    })
  })

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      if (modal2) {
        modal2.style.display = "none";
      }
    }
  }
}

// Get the contact form modal
if(document.getElementById("myModal-ithelps-contact")) {
  var modalContact = document.getElementById("myModal-ithelps-contact");  

  // Get the button that opens the modal
  var btnContact = document.getElementById("myBtn-ithelps-contact");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close-contact")[0];

  // When the user clicks on the button, open the modal
  btnContact.onclick = function() {
    modalContact.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modalContact.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modalContact.style.display = "none";
    }
  }
}

if(window.location.href.includes("contact_posted=true")) {
  if(document.getElementById("myModal-ithelps-contact")) {
    var modalContact = document.getElementById("myModal-ithelps-contact");  
    modalContact.style.display = "block";
  }
}


/*
  Swatch / size-availability / image-swap handlers are now
  registered via event delegation at the bottom of this file
  so they work for both initial AND AJAX-loaded product cards.
*/


/* Customize look section */
window.addEventListener("load", (event) => {
  if(document.querySelector(".mit-productitem-img-secondary")) {
    document.querySelectorAll(".mit-productitem-img-secondary").forEach(secondary => {

      secondary.addEventListener("mouseover", () => {
          secondary.parentElement.querySelector("img").style.opacity = "0"
      })
  
          secondary.addEventListener("mouseleave", () => {
          secondary.parentElement.querySelector("img").style.opacity = "1"
      })
    
    })
  }

  /* Menu */
  /*if(window.location.href.includes("/en")) {
    document.querySelectorAll(".header__links-list > li")[0].style.display = "none";
    document.querySelectorAll(".header__links-list > li")[2].style.display = "none";

    document.querySelectorAll(".drawer-menu__primary-links > li")[0].style.display = "none";
    document.querySelectorAll(".drawer-menu__primary-links > li")[2].style.display = "none";
    
  } else {
    document.querySelectorAll(".header__links-list > li")[1].style.display = "none";
    document.querySelectorAll(".header__links-list > li")[3].style.display = "none";

    document.querySelectorAll(".drawer-menu__primary-links > li")[1].style.display = "none";
    document.querySelectorAll(".drawer-menu__primary-links > li")[3].style.display = "none";
  }*/

});


// Size availability: initial hide (CSS now handles this via .size-availability__color { display:none })
document.addEventListener('DOMContentLoaded', function() {
  initSizeAvailability();
});

function initSizeAvailability() { 
  // Initially hide all size availability elements
  document.querySelectorAll('.product-item__size-availability').forEach(container => {
    container.style.display = 'none';
  });
  
  document.querySelectorAll('.size-availability__color').forEach(el => {
    el.style.display = 'none';
  });
}

function handleSwatchClick(e) {
  e.preventDefault();
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Get the availability container
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Make all swatches look inactive
    const allSwatches = document.querySelectorAll(`[data-prod-id="${productId}"].product-swatches-options__item--swatch`);
    allSwatches.forEach(swatch => {
      swatch.classList.remove('active-swatch');
    });
    
    // Toggle the container visibility
    const isCurrentlyVisible = availabilityContainer.classList.contains('is-visible');
    
    if (isCurrentlyVisible && availabilityContainer.getAttribute('data-current-color') === colorValue) {
      // If clicking the same color again, hide it
      availabilityContainer.classList.remove('is-visible');
      availabilityContainer.style.display = 'none';
      return;
    }
    
    // Mark this swatch as active
    this.classList.add('active-swatch');
    
    // Position the container as a relative element below the swatches section
    positionAvailabilityContainerRelative(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.classList.add('is-visible');
    availabilityContainer.style.display = 'flex';
    availabilityContainer.setAttribute('data-current-color', colorValue);
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = findColorSection(availabilityContainer, colorValue);
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

// Helper function to find color section with different approaches
function findColorSection(container, colorValue) {
  // 1. Try exact match first
  let colorSection = container.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
  
  // 2. If that fails, try with encoding
  if (!colorSection) {
    const encodedColor = encodeURIComponent(colorValue);
    colorSection = container.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
  }
  
  // 3. Try a case-insensitive match as a fallback
  if (!colorSection) {
    const allColorSections = container.querySelectorAll('.size-availability__color');
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
        colorSection = section;
        break;
      }
    }
  }
  
  // 4. Special check for colors with slashes or special characters
  if (!colorSection) {
    const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const allColorSections = container.querySelectorAll('.size-availability__color');
    
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor) {
        const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        if (normalizedColor === normalizedSectionColor) {
          colorSection = section;
          break;
        }
      }
    }
  }
  
  return colorSection;
}

// Position function for overlaying on the image
function positionAvailabilityContainerRelative(container, swatch) {
  // Find the product media element
  const productItem = swatch.closest('.product-item');
  const productMedia = productItem.querySelector('.product-item__media');
  
  if (productMedia) {
    // Remove the container from its current position if needed
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
    
    // Add the container to the product media element
    productMedia.appendChild(container);
  }
}

function handleSwatchHover(e) {
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Show the size availability on hover
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Position the container near the swatch
    positionAvailabilityContainer(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.style.display = 'block';
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = null;
    
    // 1. Try exact match first
    colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
    
    // 2. If that fails, try with encoding
    if (!colorSection) {
      const encodedColor = encodeURIComponent(colorValue);
      colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
    }
    
    // 3. Try a case-insensitive match as a fallback
    if (!colorSection) {
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
          colorSection = section;
          break;
        }
      }
    }
    
    // 4. Special check for colors with slashes or special characters
    if (!colorSection) {
      const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor) {
          const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          if (normalizedColor === normalizedSectionColor) {
            colorSection = section;
            break;
          }
        }
      }
    }
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Logging specific info about the 0/XS size if present
      const specialSize = '0/XS';
      const specialSizeElement = colorSection.querySelector(`.size-availability__item[data-size="${specialSize}"]`);
      
      if (specialSizeElement) {
        const variantId = specialSizeElement.getAttribute('data-variant-id');
        const inventory = specialSizeElement.getAttribute('data-inventory');
        const isAvailable = specialSizeElement.classList.contains('available');
      }
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

function handleSwatchLeave(e) {
  // Use a timeout to prevent flickering when moving between swatches
  setTimeout(() => {
    const productId = this.getAttribute('data-prod-id');
    const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
    
    if (availabilityContainer && !availabilityContainer.matches(':hover')) {
      availabilityContainer.style.display = 'none';
    }
  }, 200);
}

function positionAvailabilityContainer(container, swatch) {
  const swatchRect = swatch.getBoundingClientRect();
  const containerParent = swatch.closest('.product-item');
  
  if (containerParent) {
    // Append the container to the product item if it's not already there
    if (!containerParent.contains(container)) {
      containerParent.appendChild(container);
    }
    
    // Check if container should be positioned to avoid going off-screen
    const viewportWidth = window.innerWidth;
    
    // Position the container below and aligned with the swatch
    const parentRect = containerParent.getBoundingClientRect();
    const topPosition = swatchRect.bottom - parentRect.top + 5;
    let leftPosition = swatchRect.left - parentRect.left;
    
    // Adjust horizontal position if it would go off-screen
    const containerWidth = 200; // Width from CSS
    if (swatchRect.left + containerWidth > viewportWidth) {
      leftPosition = Math.max(0, viewportWidth - containerWidth - parentRect.left - 10);
    }
    
    // Set the position
    container.style.top = `${topPosition}px`;
    container.style.left = `${leftPosition}px`;
    
    // Make sure the container has its display set properly
    if (container.style.display !== 'block') {
      container.style.display = 'block';
    }
    
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    // Get the required elements
  const submitButtonGroup = document.querySelector(".product-form__controls-group--submit");
  const wishlistIcon = document.querySelector(".wishlist-hero-product-app-block");
  const productVariants = document.querySelector(".product-form__variants");
  
    if (submitButtonGroup && wishlistIcon && productVariants) {
        // Get the parent of the wishlist icon
        const wishlistParent = wishlistIcon.parentElement;
        
        // Create a new wrapper div
        const wrapperDiv = document.createElement("div");
        wrapperDiv.style.display = "flex";
        wrapperDiv.style.alignItems = "center";
        wrapperDiv.style.gap = "10px";
        
        // Create styled divs for layout
        const submitWrapper = document.createElement("div");
        submitWrapper.style.flex = "3"; // 75%
        submitWrapper.appendChild(submitButtonGroup);
        
        const wishlistWrapper = document.createElement("div");
        wishlistWrapper.style.flex = "0"; // 25%
        
        // Remove text from wishlist button, keeping only the SVG
        const wishlistButton = wishlistParent.querySelector("button");
        if (wishlistButton) {
            const wishlistSVG = wishlistButton.querySelector("svg");
            wishlistButton.innerHTML = ""; // Clear all content
            if (wishlistSVG) {
                wishlistButton.appendChild(wishlistSVG); // Re-add SVG only
            }
        }
        
        wishlistWrapper.appendChild(wishlistParent);
        
        // Append both elements to the wrapper
        wrapperDiv.appendChild(submitWrapper);
        wrapperDiv.appendChild(wishlistWrapper);
        
        // Insert the wrapper after product-form__variants
        productVariants.insertAdjacentElement("afterend", wrapperDiv);

      wishlistIcon.style.opacity = "1";
    }
  }, 1000)
  
});


function updateProductLinks(productContainer, variantUrl) {
  // Update main product link
  const productLink = productContainer.querySelector('[data-product-link]');
  if (productLink) {
    productLink.setAttribute('href', variantUrl);
  }
  
  // Update product title link
  const titleLink = productContainer.querySelector('[data-product-title-link]');
  if (titleLink) {
    titleLink.setAttribute('href', variantUrl);
  }
  
  // Update quick view buttons if they exist
  const quickViewLinks = productContainer.querySelectorAll('[data-quick-view-link], [data-quick-view-button], [data-quick-view-beneath]');
  quickViewLinks.forEach(link => {
    link.setAttribute('href', variantUrl);
  });
}

function highlightSelectedSwatch(productContainer, selectedSwatch) {
  // Remove highlight from all swatches in this product
  const allSwatches = productContainer.querySelectorAll('.product-swatches-options__item--swatch');
  allSwatches.forEach(swatch => {
    swatch.classList.remove('selected');
    // Optional: Remove any custom styling you might add
    swatch.style.border = '';
  });
  
  // Add highlight to selected swatch
  selectedSwatch.classList.add('selected');
  // Optional: Add custom styling
  
}

// =================================================================
// EVENT DELEGATION for swatch / size-availability / image-swap
// Uses document-level listeners so dynamically loaded product cards
// (via Ajaxinate "Load More") work without re-binding.
// =================================================================
(function () {

  function getVariantImageData(productContainer, productId, colorValue) {
    const imageItems = productContainer.querySelectorAll('.mit-product-image-data [data-product-id="' + productId + '"]');

    for (const item of imageItems) {
      if (item.getAttribute('data-option-color') === colorValue) {
        return item;
      }
    }

    return null;
  }

  // --- 1. Swatch click: image swap, size overlay and URL update ---
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.product-swatches-options__item--swatch');
    if (!swatch) return;

    var productId = swatch.getAttribute('data-prod-id');
    var colorValue = swatch.getAttribute('data-option-value');
    if (!productId || !colorValue) return;

    // WICHTIG: .product-item als Container nehmen, NICHT '[data-prod-id]'.
    // Das Swatch-<li> traegt selbst data-prod-id, sonst liefert closest() das
    // <li> zurueck und die Bild-/Link-Suche laeuft ins Leere (Bild wechselt nicht).
    var productContainer = swatch.closest('.product-item') || document.querySelector('.product-item[data-prod-id="' + productId + '"]');
    if (!productContainer) return;

    var imageData = getVariantImageData(productContainer, productId, colorValue);

    if (imageData) {
      var primaryEl = productContainer.querySelector('.product-item__image--one > img, .product-item__image > img');
      var secondaryEl = productContainer.querySelector('.product-item__image--two > img');
      var primarySrc = imageData.getAttribute('data-primary-src');
      var secondarySrc = imageData.getAttribute('data-secondary-src');

      if (primaryEl && primarySrc) {
        primaryEl.src = primarySrc;
        primaryEl.removeAttribute('srcset');
      }
      if (secondaryEl && secondarySrc) {
        secondaryEl.src = secondarySrc;
        secondaryEl.removeAttribute('srcset');
      }
    }

    handleSwatchClick.call(swatch, e);

    // Farbname-Label unter den Swatches aktualisieren
    var colorLabelEl = productContainer.querySelector('[data-selected-color]');
    if (colorLabelEl) {
      var colorPrefix = colorLabelEl.getAttribute('data-color-label') || '';
      colorLabelEl.textContent = colorPrefix ? (colorPrefix + ': ' + colorValue) : colorValue;
    }

    var variantUrl = swatch.getAttribute('data-variant-url');
    if (variantUrl) {
      updateProductLinks(productContainer, variantUrl);
      highlightSelectedSwatch(productContainer, swatch);
    }
  });

  // --- 2. Swatch hover: Variantenbild vorab laden ---
  // Warmt den Browser-Cache, sobald der Nutzer ueber einen Swatch faehrt.
  // Dadurch ist das Bild beim eigentlichen Klick i. d. R. schon geladen und
  // der Wechsel wirkt verzoegerungsfrei (kein Netzwerk-Delay mehr).
  var prefetchedSwatchSrc = {};

  function prefetchSwatchImage(swatch) {
    var productId = swatch.getAttribute('data-prod-id');
    var colorValue = swatch.getAttribute('data-option-value');
    if (!productId || !colorValue) return;

    var productContainer = swatch.closest('.product-item');
    if (!productContainer) return;

    var imageData = getVariantImageData(productContainer, productId, colorValue);
    if (!imageData) return;

    ['data-primary-src', 'data-secondary-src'].forEach(function (attr) {
      var src = imageData.getAttribute(attr);
      if (src && !prefetchedSwatchSrc[src]) {
        prefetchedSwatchSrc[src] = true;
        var img = new Image();
        img.decoding = 'async';
        img.src = src; // laedt im Hintergrund in den Cache
      }
    });
  }

  document.addEventListener('pointerover', function (e) {
    var swatch = e.target.closest('.product-swatches-options__item--swatch');
    if (swatch) prefetchSwatchImage(swatch);
  });

  // --- 4. "Show more swatches" link ---
  document.addEventListener('click', function (e) {
    var showMore = e.target.closest('.mit-show-hidden-swatches');
    if (!showMore) return;
    e.preventDefault();

    var productContainer = showMore.closest('.product-item');
    if (productContainer) {
      productContainer.querySelectorAll('[data-visible="hidden"]').forEach(function (sw) {
        sw.setAttribute('data-visible', 'visible');
        sw.style.display = 'inline-block';
      });
    }
    showMore.style.display = 'none';
  });

  // --- 5. MutationObserver: re-init size-availability state for AJAX-loaded products ---
  function observeCollectionGrid() {
    var grid = document.querySelector('.collection__infinite-container');
    if (!grid) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          initSizeAvailability();
          return;
        }
      }
    }).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCollectionGrid);
  } else {
    observeCollectionGrid();
  }

})();

// Accessibility labels for third-party widgets that are injected after page load.
(function () {
  var accessibilityFixQueued = false;

  function setButtonName(button, label) {
    if (!button) return;
    if (!button.getAttribute('aria-label') && !button.getAttribute('title') && !button.textContent.trim()) {
      button.setAttribute('aria-label', label);
    }
  }

  function setImportantStyle(element, property, value) {
    if (!element || !element.style) return;
    element.style.setProperty(property, value, 'important');
  }

  function applyExternalAccessibilityFixes() {
    var previewFrame = document.getElementById('PBarNextFrame');
    if (previewFrame && !previewFrame.getAttribute('title')) {
      previewFrame.setAttribute('title', 'Shopify preview bar');
    }

    document.querySelectorAll('button.chat-toggle').forEach(function (button) {
      setButtonName(button, 'Chat öffnen');
    });

    document.querySelectorAll('inbox-online-store-chat').forEach(function (widget) {
      if (!widget.shadowRoot) return;

      setButtonName(widget.shadowRoot.querySelector('button.chat-toggle'), 'Chat öffnen');
    });

    // Vision AI "similar products" thumbnails are injected without an accessible
    // name (the app sets the image alt asynchronously). Give each link a name.
    document.querySelectorAll('a.xsvai-item__thumbnail').forEach(function (link) {
      if (link.getAttribute('aria-label')) return;

      var name = '';
      var img = link.querySelector('img');
      if (img && img.getAttribute('alt')) {
        name = img.getAttribute('alt').trim();
      }
      if (!name) {
        var item = link.closest('.xsvai-item');
        var titleEl = item && item.querySelector('[class*="title"], [class*="name"]');
        if (titleEl) name = titleEl.textContent.trim();
      }

      link.setAttribute('aria-label', name || 'Produkt ansehen');
    });
  }

  function queueExternalAccessibilityFixes() {
    if (accessibilityFixQueued) return;
    accessibilityFixQueued = true;

    window.setTimeout(function () {
      accessibilityFixQueued = false;
      applyExternalAccessibilityFixes();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyExternalAccessibilityFixes);
  } else {
    applyExternalAccessibilityFixes();
  }

  window.addEventListener('load', applyExternalAccessibilityFixes);

  new MutationObserver(queueExternalAccessibilityFixes).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// =================================================================
// Scroll-/Positions-Wiederherstellung fuer Collections & Suche mit
// "Mehr laden" (Ajaxinate).
//
// Ziel: Klickt man in einer Kollektion auf ein Produkt und kehrt
// danach zurueck, landet man wieder an exakt der Stelle (inkl. der
// bereits nachgeladenen Produkte), an der man das Produkt angeklickt hat.
//
// Funktionsweise:
//  1. Beim Verlassen der Seite (pagehide) werden Scrollposition und die
//     Anzahl aktuell geladener Produkte (pro Collection-URL) gespeichert.
//  2. Nur bei echter Zurueck-Navigation werden so oft "Mehr laden" ausgeloest,
//     bis wieder gleich viele Produkte da sind, danach wird zur Scrollposition
//     gesprungen. Ajaxinate laedt synchron, deshalb genuegt eine einfache Schleife.
//     Ein Capture-Guard verhindert, dass der Link je echt navigiert.
// =================================================================
(function () {
  var GRID = '.collection__infinite-container, .search__infinite-container';
  var TRIGGER = '.collection__infinite-trigger, .search__infinite-trigger';
  var ITEM = '.product-item';

  function getGrid() { return document.querySelector(GRID); }
  function itemCount() {
    var grid = getGrid();
    return grid ? grid.querySelectorAll(ITEM).length : 0;
  }
  function stateKey() {
    return 'fs-collpos:' + window.location.pathname + window.location.search;
  }

  // Nur bei echter Zurueck-/Vorwaerts-Navigation wiederherstellen,
  // NICHT wenn die Kollektion frisch (z. B. ueber das Menue) geoeffnet wird.
  function isBackForward() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type === 'back_forward';
    } catch (e) {}
    try {
      if (performance.navigation) return performance.navigation.type === 2;
    } catch (e) {}
    return false;
  }

  // Hinweis: history.scrollRestoration = 'manual' und das Ausblenden des Inhalts
  // (Klasse 'fs-pos-restoring') passieren bereits im Inline-Script im <head>,
  // damit kein Aufblitzen entsteht. Hier wird nur wiederhergestellt und wieder eingeblendet.

  function revealPage() {
    document.documentElement.classList.remove('fs-pos-restoring');
  }

  // --- 1. Zustand beim Verlassen der Seite speichern ---
  // pagehide deckt jede Art des Verlassens ab (Produktklick, Menue, etc.).
  window.addEventListener('pagehide', function (e) {
    if (e.persisted) return; // geht in den bfcache -> kommt 1:1 zurueck, kein Speichern noetig
    if (!getGrid()) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify({
        scrollY: window.scrollY || window.pageYOffset || 0,
        count: itemCount()
      }));
    } catch (err) {}
  });

  // Loest einmal "Mehr laden" aus, ohne dass der Link je navigiert.
  // Gibt true zurueck, wenn Produkte dazugekommen sind.
  function loadMoreOnce() {
    var trigger = document.querySelector(TRIGGER);
    var link = trigger && trigger.querySelector('a[href]');
    if (!link) return false;

    var guard = function (ev) { ev.preventDefault(); }; // verhindert echte Navigation
    link.addEventListener('click', guard, true);
    var before = itemCount();
    link.click(); // Ajaxinate laedt synchron und haengt Produkte an
    link.removeEventListener('click', guard, true);

    return itemCount() > before;
  }

  // --- 2. Zustand bei Rueckkehr wiederherstellen ---
  function restorePosition() {
    if (!getGrid()) return;
    if (!isBackForward()) return;

    var raw;
    try { raw = sessionStorage.getItem(stateKey()); } catch (err) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(stateKey()); } catch (err) {}

    var state;
    try { state = JSON.parse(raw); } catch (err) { return; }
    if (!state) return;

    var target = state.count || 0;
    var safety = 0;
    while (itemCount() < target && safety < 50) {
      safety++;
      if (!loadMoreOnce()) break;
    }

    var y = state.scrollY || 0;
    // Zwei Versuche: sofort und nach dem naechsten Frame (Bilder/Layout),
    // damit die Zielposition auch bei spaetem Layout-Shift stimmt.
    window.scrollTo(0, y);
    window.requestAnimationFrame(function () { window.scrollTo(0, y); });
  }

  window.addEventListener('pageshow', function (e) {
    // bfcache: Seite inkl. Produkte & Scrollposition ist bereits 1:1 wieder da.
    if (e.persisted) { revealPage(); return; }
    // kurz warten, bis die Collection-Komponente (Ajaxinate) initialisiert ist,
    // danach wiederherstellen und Inhalt wieder einblenden.
    window.setTimeout(function () {
      try { restorePosition(); } finally { revealPage(); }
    }, 60);
  });
})();
